import React, { useState, useEffect } from 'react';
import { fetchQuickBooksCustomers } from './api';

const MAX_RESULTS = 50;

// Search QuickBooks customers and pick one to link. `value` is { id, name } (empty id = not
// linked); onChange is called with the same shape, or { id: '', name: '' } to unlink.
const QuickBooksCustomerPicker = ({ value, onChange }) => {
  const [qbCustomers, setQbCustomers] = useState(null);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    fetchQuickBooksCustomers()
      .then(customers => setQbCustomers(customers || []))
      .catch(() => {
        setQbCustomers([]);
        setError('Could not load QuickBooks customers. Check that QuickBooks is connected.');
      });
  }, []);

  const term = search.trim().toLowerCase();
  const matches = (qbCustomers || [])
    .filter(c => !term
      || c.name.toLowerCase().includes(term)
      || (c.company_name && c.company_name.toLowerCase().includes(term)))
    .slice(0, MAX_RESULTS);

  const select = (customer) => {
    onChange({ id: customer.id, name: customer.name });
    setSearch('');
    setOpen(false);
  };

  return (
    <div className="qb-customer-picker">
      {value.id ? (
        <div className="qb-customer-picker-linked">
          <span>{value.name || `QuickBooks customer #${value.id}`}</span>
          <button type="button" className="customer-additional-email-remove" onClick={() => onChange({ id: '', name: '' })}>
            Unlink
          </button>
        </div>
      ) : (
        <span className="customer-info-hint">Not linked. Invoices will ask which QuickBooks customer to use.</span>
      )}
      <input
        className="customer-info-input"
        type="text"
        value={search}
        onChange={(e) => { setSearch(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 200)}
        placeholder={qbCustomers === null ? 'Loading QuickBooks customers...' : 'Search QuickBooks customers...'}
        disabled={qbCustomers === null}
      />
      {open && matches.length > 0 && (
        <div className="qb-customer-picker-dropdown">
          {matches.map(c => (
            <div key={c.id} className="qb-customer-picker-option" onMouseDown={() => select(c)}>
              <div>{c.name}</div>
              {c.company_name && c.company_name !== c.name && <small>{c.company_name}</small>}
            </div>
          ))}
        </div>
      )}
      {error && <div className="customer-save-error" role="alert">{error}</div>}
    </div>
  );
};

export default QuickBooksCustomerPicker;
